import {
  Action,
  autoBatchEnhancer,
  combineReducers,
  configureStore,
  ThunkAction,
} from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import * as Sentry from '@sentry/react'

import { signupApi } from './services'

const sentryEnhancer = Sentry.createReduxEnhancer({
  stateTransformer: (state) => {
    if (state.signupApi) {
      return null
    }
  },
})

export const reducers = combineReducers({
  [signupApi.reducerPath]: signupApi.reducer,
})

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(signupApi.middleware),
  enhancers: (existingEnhancers) => {
    return existingEnhancers().concat(autoBatchEnhancer()).concat(sentryEnhancer)
  },
})

setupListeners(store.dispatch)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
